import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import RestorationPreview from "@/pages/RestorationPreview";

export const Route = createFileRoute("/_public/restoration-preview")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("See Your Fence Restored \u2014 Free AI Preview | Modern Fence Install", "Upload a photo of your existing chain-link or metal-post fence and our AI will show you what it would look like restored with our professional-grade non-electric containment mesh. Free, instant, no obligation.", "/restoration-preview", false),
  component: RestorationPreview,
});
